import WIPFeaturesContext from 'context/wip-features/wip-features.context';
import { useI18n } from 'hooks/useI18n';
import { UIOfferPerk } from 'interfaces/ui/ui-offer-perk';
import { UIOfferPerks } from 'interfaces/ui/ui-offer-perks';
import { useContext } from 'react';
import {
  StyledOfferPerks,
  StyledOfferPerksExtra,
  StyledOfferPerksMain,
  StyledOfferPerksMainPerks,
  StyledOfferPerksMainTitle
} from './OfferPerks.styled';
import OfferPerksItem from './OfferPerksItem';

const OfferPerks = ({ perks }: { perks: UIOfferPerks }) => {
  const { t } = useI18n('job-offer');
  const showWIPFeatures = useContext(WIPFeaturesContext);

  return (
    <StyledOfferPerks>
      {showWIPFeatures &&
        perks.compensation &&
        perks.compensation.length > 0 && (
          <StyledOfferPerksMain>
            <StyledOfferPerksMainTitle>
              {t('offer.flexRetribution')}
            </StyledOfferPerksMainTitle>
            <StyledOfferPerksMainPerks>
              {perks.compensation.map((p, i) => (
                <OfferPerksItem key={i} perksItem={p} />
              ))}
            </StyledOfferPerksMainPerks>
          </StyledOfferPerksMain>
        )}

      {perks.extra && perks.extra.length > 0 && (
        <StyledOfferPerksExtra>
          {perks.extra.map((p: UIOfferPerk | void, i: number) => (
            <OfferPerksItem key={i} perksItem={p} />
          ))}
        </StyledOfferPerksExtra>
      )}
    </StyledOfferPerks>
  );
};

export default OfferPerks;
